/**
 * @file SickleMedication.js
 * @description This file contains the SickleMedication component.
 * @author Nadeem Ahamad
 * @since 2025-06-18
 */
import React, { useEffect, useState, useCallback } from "react";
import { sickleAPI } from "../../../services/sickle.api";
import Loader from "../../../components/Loader";
import { Collapse } from 'bootstrap';
import { toast } from "react-toastify";

const SickleMedication = ({ onClose, sickleId }) => {

    const [accordianDisabled, setAccordianDisabled] = useState(true);
    const [medicalHistoryList, setMedicalHistoryList] = useState([]);
    const [medicineList, setMedicineList] = useState([]);
    const [labInvestigationList, setlabInvestigationList] = useState([]);
    const [bloodTransfusionList, setBloodTransfusionList] = useState([]);
    const [vaccinationList, setVaccinationList] = useState([]);
    const [patientProfile, setProfileProfiles] = useState([]);
    const [bloodGroups, setBloodGroups] = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [treatmentId] = useState("");
    const [diseaseID] = useState(1);
    const [medicineTreatmentId] = useState("");

    /**
     * This function is used to get the diseased beneficiaries.
     * 
     */

    const getDiseasedBeneficiaries = useCallback(async () => {
        setIsPageLoading(true);
        try {
            const payload = {
                sickle_id: sickleId,
                disease_type: 1
            };
            const resp = await sickleAPI.getDiseasedBeneficiaries(payload);
            if (resp.status === 1) {
                if (resp?.PatientDetails?.length > 0) {
                    setProfileProfiles(resp?.PatientDetails[0]);
                    setIsPageLoading(false);
                } else {
                    toast.error("Beneficiaries diseased not found! Please do any test")
                }
            } else {
                setIsPageLoading(false);
                toast.error("Data not found");
            }
        } catch (error) {
            console.error("Error in get Diseased Beneficiaries: ", error);
        }
    }, [sickleId]);

    /**
     * This function is used to get the blood groups.
     */
    const hadlebloodGroups = async () => {
        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getBloodGroups();
            if (resp.status === 1) {
                const dtbloodgroups = resp?.BloodGroups || [];
                setBloodGroups(dtbloodgroups);
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("Blood groups not found");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in getPatientRegDetails:", error);
        }
    };

    /**
     * This function is used to get the medical history.
     */

    const handleMedicalHistory = useCallback(async () => {

        setIsPageLoading(true);
        try {

            const payload = {
                "sickle_id": Number(sickleId),
                "disease_id": 1,
            };
            const dtResponse = await sickleAPI.getMedicalHistory(payload);
            if (dtResponse.status === 1) {
                setMedicalHistoryList(dtResponse.PatientDetails);
                setTimeout(() => {
                    setIsPageLoading(false);
                    setAccordianDisabled(false);
                    const profileEl = document.getElementById('collapseProfile');
                    const medicineEl = document.getElementById('collapseMedicine');

                    if (profileEl && profileEl.classList.contains('show')) {
                        const profileCollapse = Collapse.getInstance(profileEl) || new Collapse(profileEl, { toggle: false });
                        profileCollapse.hide();
                    }

                    if (medicineEl && !medicineEl.classList.contains('show')) {
                        const medicineCollapse = Collapse.getInstance(medicineEl) || new Collapse(medicineEl, { toggle: false });
                        medicineCollapse.show();
                    }
                }, 3000);

            } else {
                setIsPageLoading(false);
                toast.error("Error in getting medical history");
            }

        } catch (error) {
            console.error("Error in getPatientRegDetails:", error);
        }
    }, [sickleId]);

    useEffect(() => {
        hadlebloodGroups();
        getDiseasedBeneficiaries();
        handleMedicalHistory();
    }, [getDiseasedBeneficiaries, handleMedicalHistory]);

    useEffect(() => {
        console.log("call registrationDetails", patientProfile);
        console.log("call bloodGroups", bloodGroups);
    }, [bloodGroups, patientProfile]);

    useEffect(() => {
        console.log("call medicalHistoryList", medicalHistoryList);
    }, [medicalHistoryList]);

    /**
     * This function is used to get the medical history.
     * @param {*} treatment_id 
     * @param {*} visit_id 
     */

    const viewMedicalHistory = async (treatment_id, visit_id) => {
        try {
            await viewMedicine(treatment_id, visit_id);
            await viewLabInvestigation(treatment_id, visit_id);
            await viewBloodTransfusion(treatment_id, visit_id);
            await viewVaccine(treatment_id, visit_id);
        } catch (error) {

        }
    }

    /**
     * This function is used to get the medicine list.
     * @param {*} treatment_id 
     * @param {*} visit_id 
     */

    const viewMedicine = async (treatment_id, visit_id) => {
        try {
            setMedicineList([]);
            setIsPageLoading(true);
            const RequestPayload = {
                "sickle_id": Number(sickleId),
                "disease_id": diseaseID,
                "visit_no": visit_id,
                "treatment_id": treatment_id
            }
            const medicineShowResponse = await sickleAPI.showMedicine(RequestPayload);
            if (medicineShowResponse.status === 1) {
                setMedicineList(medicineShowResponse.PatientDetails);
                setTimeout(() => {
                    setIsPageLoading(false);
                }, 1000);
            } else {
                setIsPageLoading(false);
                toast.error("error in medicineShow");
            }
        } catch (error) {

        }
    }

    /**
     * This function is used to delete the medicine.
     * @param {*} medicineId
     */
    const deleteMedicineById = async (medicineId) => {
        try {
            if (window.confirm("Are you sure you want to delete this?")) {
                const payload = { "treatment_id": Number(medicineTreatmentId), "id": Number(medicineId) }
                const deleteResponse = await sickleAPI.deleteMedicine(payload);
                if (deleteResponse.status === 1) {
                    toast.success("Medicine deleted successfully");
                } else {
                    toast.error("Error in deleting medicine");
                }
            } else {
                toast.error("Cancelled.");
            }
        } catch (error) {
            toast.error("Error in delete medicine:", error);
        }
    }

    /**
     * This function is used to view the lab investigation.
     * @param {*} treatment_id 
     * @param {*} visit_id 
     */

    const viewLabInvestigation = async (treatment_id, visit_id) => {
        try {
            setlabInvestigationList([]);
            setIsPageLoading(true);
            const RequestPayload = {
                "sickle_id": Number(sickleId),
                "disease_id": diseaseID,
                "visit_no": visit_id,
                "treatment_id": treatment_id
            }
            const dtResponse = await sickleAPI.showLabInvestigation(RequestPayload);
            if (dtResponse.status === 1) {
                setlabInvestigationList(dtResponse.PatientDetails);
                setTimeout(() => {
                    setIsPageLoading(false);
                }, 1000);
            } else {
                setIsPageLoading(false);
                toast.error("error in lab investigation list");
            }
        } catch (error) {

        }
    }

    /**
     * This function is used to delete the lab investigation.
     * @param {*} investigation_id 
     */

    const deleteLabInvestigationById = async (investigation_id) => {
        try {
            if (window.confirm("Are you sure you want to delete this?")) {
                const payload = { "treatment_id": treatmentId, "id": investigation_id };
                const deleteResponse = await sickleAPI.deleteLabInvestigation(payload);
                if (deleteResponse.status === 1) {
                    toast.success("Medicine deleted successfully");
                } else {
                    toast.error("Error in deleting medicine");
                }
            } else {
                toast.error("Cancelled.");
            }
        } catch (error) {
            toast.error("Error in Delete Medicine:", error);
        }
    }

    /**
     * This function is used to view the blood transfusion.
     * @param {*} investigation_id 
     */

    const viewBloodTransfusion = async (treatment_id, visit_id) => {
        try {
            setBloodTransfusionList([]);
            setIsPageLoading(true);
            const RequestPayload = {
                "sickle_id": Number(sickleId),
                "disease_id": diseaseID,
                "visit_no": visit_id,
                "treatment_id": treatment_id
            }
            const medicineShowResponse = await sickleAPI.getBloodTransfusion(RequestPayload);
            if (medicineShowResponse.status === 1) {
                setBloodTransfusionList(medicineShowResponse.PatientDetails);
                setTimeout(() => {
                    setIsPageLoading(false);
                }, 1000);
            } else {
                setIsPageLoading(false);
                toast.error("error in blood transfusion list");
            }
        } catch (error) {
            setIsPageLoading(false);
            toast.error("error in blood transfusion list");
        }
    }

    /**
     * This function is used to delete the lab investigation.
     * @param {*} investigation_id 
     */

    const deleteBloodTransfusionById = async (investigation_id) => {
        try {
            if (window.confirm("Are you sure you want to delete this?")) {
                const payload = { "treatment_id": treatmentId, "id": investigation_id };
                const deleteResponse = await sickleAPI.deleteBloodTransfusion(payload);
                if (deleteResponse.status === 1) {
                    toast.success("Medicine deleted successfully");
                } else {
                    toast.error("Error in deleting medicine");
                }
            } else {
                toast.error("Cancelled.");
            }
        } catch (error) {
            toast.error("Error in Delete Medicine:", error);
        }
    }

    /**
     * This function is used to view the vaccine.
     * @param {*} investigation_id 
     */
    const viewVaccine = async (treatment_id, visit_id) => {
        try {
            setVaccinationList([]);
            setIsPageLoading(true);
            const RequestPayload = {
                "sickle_id": Number(sickleId),
                "disease_id": diseaseID,
                "visit_no": visit_id,
                "treatment_id": treatment_id
            }
            const vaccineResponse = await sickleAPI.getVaccine(RequestPayload);
            if (vaccineResponse.status === 1) {
                setVaccinationList(vaccineResponse.data);
                setTimeout(() => {
                    setIsPageLoading(false);
                }, 1000);
            } else {
                setIsPageLoading(false);
                toast.error("error in vaccine list");
            }
        } catch (error) {

        }
    }

    /**
     * This function is used to delete the lab investigation.
     * @param: {*}  treatmentId, immunization_id  
     */

    const deleteVaccineById = async (treatmentId, immunization_id) => {
        try {
            if (window.confirm("Are you sure you want to delete this?")) {
                const payload = { "treatment_id": treatmentId, "id": immunization_id };
                const deleteResponse = await sickleAPI.deleteVaccine(payload);
                if (deleteResponse.status === 1) {
                    toast.success("Vaccine deleted successfully");
                } else {
                    toast.error("Error in deleting vaccine");
                }
            } else {
                toast.error("Cancelled.");
            }
        } catch (error) {
            toast.error("Error in Delete vaccine:", error);
        }
    }

    return (
        <>
            
            {isPageLoading && <Loader />}
            <div className="sickleMedicationSection">
                {/* <div className="sickleMedicationBoxRow">
                    <div className="sickelMedBox">
                        <div className="iconValue">
                            <img src={"/images/Sick/arcticons_laos-health.png"} />
                            <span className="value">20</span>
                        </div>
                        <p>Treatment count <br />by user in the HF.:</p>
                    </div>
                    <div className="sickelMedBox">
                        <div className="iconValue">
                            <img src={"/images/Sick/healthicons_doctor-outline.png"} />
                            <span className="value">02</span>
                        </div>
                        <p>Visit No.:</p>
                    </div>
                </div> */}
                {/* ------------End Box Section----------- */}

                <div className="accordion" id="sickAccordion">
                    <div className="patientDetailsTitleHeader-h d-flex mb-0">
                        <div className="leftHeaderBar">
                            <span><img src={"/images/Sickel.svg"} alt="" style={{ width: "43px", margin:"10px 0 0 14px" }} /></span>
                            <h4>Sickle Medical History</h4>
                        </div>
                        <div className="closeDive sickleclose" onClick={() => onClose('handleCloseSickleMedication')}><img src={"/images/closing.svg"} alt="Close" /></div>
                    </div>
                    {/* Patient Profile */}
                    {medicalHistoryList && medicalHistoryList.length > 0 && (
                        <div className="medical-history-row">
                            {medicalHistoryList.map((visit, idx) => (
                                <div
                                    key={visit.Visit_id || idx}
                                    className="history-card"
                                    onClick={() => viewMedicalHistory(visit.Treatment_id, visit.Visit_id)}
                                >
                                    <div className="card-row">
                                        <span className="label">Visit Date:</span>
                                        <span className="value">{visit.Visit_date || 'N/A'}</span>
                                    </div>
                                    <div className="card-row">
                                        <span className="label">Visit ID:</span>
                                        <span className="value">{visit.Visit_id || 'N/A'}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingProfile">
                            <button className="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseProfile" aria-expanded="true" aria-controls="collapseProfile">
                                Patient Profile
                            </button>
                        </h2>
                        <div id="collapseProfile" className="accordion-collapse collapse show" aria-labelledby="headingProfile" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">
                                {/* --- ORIGINAL Patient Profile tab content --- */}

                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div className="tabsBodySickle">
                                        {/* <div className="tabsSickleHeader">

                                            <div className="sicleHeaderActionMixedBtn">
                                                <div className="customebtngroup">
                                                    <button className="first">Update</button>
                                                    <button className="last">View</button>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="patientProfileSickelMedication medicationFeilds">
                                            <div className="medicationFeildsRow">
                                                <div className="feild">
                                                    <label>Sickle ID </label>
                                                    <input type="text" value={patientProfile?.sickle_id} disabled={true} />
                                                </div>

                                                <div className="feild">
                                                    <label>Registration Date</label>
                                                    <input type="text" value={patientProfile?.registration_date} disabled={true} />
                                                </div>

                                                <div className="feild">
                                                    <label>Blood Group </label>
                                                    <select value={patientProfile?.blood_group} disabled={true}>
                                                        <option>Select Blood Group</option>
                                                        {bloodGroups.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.bg_name}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="feild">
                                                    <label>Last Visit</label>
                                                    <input type="text" value={patientProfile?.last_visit ? patientProfile?.last_visit : 'N/A'} disabled={true} />
                                                </div>
                                            </div>
                                            {/* <div className="ProceedtoTreatment mt-3">
                                                <h4>Proceed to  Treatment?</h4>
                                                <div className="ProceedTreatmentAction">
                                                    <button onClick={() => handleConfirm()}>Confirm</button>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Medicine */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingMedicine">
                            <button
                                className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseMedicine" aria-expanded="true" aria-controls="collapseMedicine">
                                Medicine <span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseMedicine" className="accordion-collapse collapse" aria-labelledby="headingMedicine" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">
                                <div className="tabsBodySickle">
                                    <div className="medicationTable">
                                        <div className="tableRows mb-3">
                                            {/* <h4>Medicine Details</h4> */}
                                            <div className="table-responsive">
                                                <table className='table table-bordered'>
                                                    <thead>
                                                        <tr>

                                                            <th>Drug Snomed</th>
                                                            <th>Drug Name</th>
                                                            <th>Quantity
                                                                Prescribed</th>
                                                            <th>Quantity
                                                                Dispensed</th>
                                                            <th>Date
                                                                Prescribed</th>
                                                            <th>Date
                                                                Dispensed</th>
                                                            <th>HF Name
                                                                Precribed</th>
                                                            <th>HF Name
                                                                Dispensed</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <>
                                                            {medicineList && medicineList.length > 0 ? (
                                                                medicineList.map((item, index) => (
                                                                    <tr key={item.medicine_id || index}>
                                                                        <td>{item.drug_snomed}</td>
                                                                        <td>{item.drug_name}</td>
                                                                        <td>{item.quantity_prescribed}</td>
                                                                        <td>{item.quantity_dispensed}</td>
                                                                        <td>{item.date_prescribed}</td>
                                                                        <td>{item.date_dispensed}</td>
                                                                        <td>{item.hf_name_precribed}</td>
                                                                        <td>{item.hf_name_dispensed}</td>
                                                                        <td onClick={() => deleteMedicineById(item.medicine_id, item.drug_id)}>
                                                                            <span className="dlt">
                                                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="9">No data available</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Lab Investigation */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingLab">
                            <button className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseLab" aria-expanded="false" aria-controls="collapseLab">
                                Lab Investigation<span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseLab" className="accordion-collapse collapse" aria-labelledby="headingLab" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">
                                {/* --- ORIGINAL Lab Investigation tab content --- */}

                                <div className="tabsBodySickle">
                                    <div className="medicationTable">
                                        <div className="tableRows mb-3">

                                            <div className="table-responsive">
                                                <table className='table table-bordered'>
                                                    <thead>
                                                        <tr>

                                                            <th>Test Snomed</th>
                                                            <th>Test Name</th>
                                                            <th>Sample Collection Date</th>
                                                            <th>Result Date</th>
                                                            <th>Test Result Name</th>
                                                            <th>HF Name </th>
                                                            <th>Action</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <>
                                                            {labInvestigationList && labInvestigationList.length > 0 ? (
                                                                labInvestigationList.map((item, index) => (
                                                                    <tr>
                                                                        <td>{item.test_snomed}</td>
                                                                        <td>{item.test_name}</td>
                                                                        <td>{item.sample_collection_date}</td>
                                                                        <td>{item.result_date}</td>
                                                                        <td>{item.test_result_name}</td>
                                                                        <td>{item.hf_name}</td>
                                                                        <td onClick={() => deleteLabInvestigationById(item.investigation_id)}>
                                                                            <span className="dlt">
                                                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="7">No data available</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Blood Transfusion */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingBlood">
                            <button className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseBlood" aria-expanded="false" aria-controls="collapseBlood">
                                Blood Transfusion<span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseBlood" className="accordion-collapse collapse " aria-labelledby="headingBlood" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">

                                <div className="tabsBodySickle">
                                    <div className="medicationTable">
                                        <div className="tableRows mb-3">

                                            <div className="table-responsive">
                                                <table className='table table-bordered'>
                                                    <thead>
                                                        <tr>
                                                            <th>Transfusion Date</th>
                                                            <th>Transfusion HF Name</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {bloodTransfusionList && bloodTransfusionList.length > 0 ? (
                                                            bloodTransfusionList.map((item, index) => (
                                                                <tr>
                                                                    <td>{item.transfusion_date}</td>
                                                                    <td>{item.transfusion_hf_name}</td>
                                                                    <td onClick={() => deleteBloodTransfusionById(item.transfusion_id)}>
                                                                        <span className="dlt">
                                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3">No data available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Vaccination */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingVaccination">
                            <button className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseVaccination" aria-expanded="false" aria-controls="collapseVaccination">
                                Vaccination<span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseVaccination" className="accordion-collapse collapse" aria-labelledby="headingVaccination" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">

                                <div className="tabsBodySickle">
                                    <div className="medicationTable">
                                        <div className="tableRows mb-3">

                                            <div className="table-responsive">
                                                <table className='table table-bordered'>
                                                    <thead>
                                                        <tr>
                                                            <th>Vaccine Snomed</th>
                                                            <th>Vaccine Name</th>
                                                            <th>Dose Count</th>
                                                            <th>Vaccination Date</th>
                                                            <th>Next Vaccine Date</th>
                                                            <th>HF Name</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {vaccinationList && vaccinationList.length > 0 ? (
                                                            vaccinationList.map((item) => (
                                                                <tr>
                                                                    <td>{item.vaccine_snomed}</td>
                                                                    <td>{item.vaccine_name}</td>
                                                                    <td>{item.dose_id}</td>
                                                                    <td>{item.vaccination_date}</td>
                                                                    <td>{item.next_vaccine_date}</td>
                                                                    <td>{item.hf_name}</td>
                                                                    <td onClick={() => deleteVaccineById(item.immunization_id)}>
                                                                        <span className="dlt">
                                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="7">No data available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default SickleMedication
